import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Grid } from '@mui/material';
import Container from './Container';

const ReviewContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: theme.palette.background.default,
  minHeight: '100vh',
}));

const ReviewItem = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
}));

const reviews = [
  { title: 'Review', value: '1', color: '#2196f3' },
  { title: 'Review', value: '2', color: '#2196f3' },
  { title: 'Review', value: '3', color: '#2196f3' },
  { title: 'Kritik', value: '1', color: '#e91e63' },  
  { title: 'Review', value: '1', color: '#2196f3' },
  { title: 'Review', value: '2', color: '#2196f3' },
  { title: 'Review', value: '3', color: '#2196f3' },
  { title: 'Kritik', value: '1', color: '#e91e63' },
];

const Review: React.FC = () => {
  return (
    <ReviewContainer>
      <Container title="Reviews">
        <Grid container spacing={3}>
          {reviews.map((review, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <ReviewItem>
                <Typography variant="h6" gutterBottom>
                  {review.title}
                </Typography>
                <Typography variant="h4" style={{ color: review.color }}>
                  {review.value}
                </Typography>
              </ReviewItem>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ReviewContainer>
  );
};

export default Review;
